import { useState } from "react";
import "@/App.css";
import useLenis from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Skills } from "@/components/Skills";
import { Experience } from "@/components/Experience";
import { Education } from "@/components/Education";
import { Contact } from "@/components/Contact";
import { CONTENT } from "@/data/content";

function App() {
  useLenis();
  const [lang, setLang] = useState("pt");
  const t = CONTENT[lang];

  return (
    <div className="App" data-testid="app-root">
      <div className="grain-overlay" />
      <Navbar lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <About t={t} />
        <Education t={t} />
        <Skills t={t} />
        <Experience t={t} />
        <Contact t={t} />
      </main>
    </div>
  );
}

export default App;
